import {
  getVisaG8LabelFromValue,
  options as visaG8Options,
} from "@/components/input/custom/visa/VisaG8";
import { cn } from "@/lib/utils";
import { EntryValueLabel } from "../EntryValueLabel";
import type { BaseEntryValueProps } from "./BaseEntryValue";

export interface VisaG8EntryValueProps
  extends Omit<BaseEntryValueProps, "value"> {
  value: number | null;
}

export function VisaG8EntryValue(
  { value, inputLabel, size, className, ...props }: VisaG8EntryValueProps,
) {
  const result = value != null ? getVisaG8LabelFromValue(value) : null;
  const branchAnswer = result
    ? visaG8Options.find((opt) => opt.value === result.branch)?.answer
    : null;

  return (
    <div>
      <EntryValueLabel size={size}>
        Does your current hip pain affect your ability to undertake weight
        bearing activities? (e.g. walking, shopping, running, squats, lunges).
      </EntryValueLabel>
      <div className="flex flex-col gap-1 pt-2">
        {branchAnswer && (
          <span
            className={cn(
              "mb-1 text-md text-slate-700",
              size === "sm" ? "text-sm" : "text-md",
            )}
          >
            {branchAnswer}
          </span>
        )}
        {result && (
          <span
            className={cn(
              "text-slate-700 dark:text-white",
              size === "sm" ? "text-md" : "text-lg",
            )}
          >
            {result.label}
          </span>
        )}
      </div>
    </div>
  );
}
